module.exports = __webpack_public_path__ + "img/saum_gruen_candy.d7fa5985.jpg";